import React from "react";
import AuthField from "../Auth/AuthField";
import { i18n } from "../../translate/i18n";

const ModalStepTwo = ({ headers, columns, setColumns }) => {
	const handleColumns = (field, selectedColumn) => {
		setColumns((prevState) => ({
			...prevState,
			[field]: selectedColumn,
		}));
	};

	return (
		<div className="app-import-step-content space-y-4">
			<p className="m-0 text-sm text-default-600 dark:text-default-400">
				{i18n.t("contactsImportModal.stepTwo.intro")}
			</p>

			<AuthField
				id="import-column-name"
				label={i18n.t("contactsImportModal.stepTwo.name")}
			>
				<select
					id="import-column-name"
					className="form-select w-full"
					onChange={(e) => handleColumns("name", e.target.value)}
					value={columns.name}
				>
					<option value="">{i18n.t("contactsImportModal.stepTwo.select")}</option>
					{headers.map((header) => (
						<option key={header} value={header}>
							{header}
						</option>
					))}
				</select>
			</AuthField>

			<AuthField
				id="import-column-number"
				label={i18n.t("contactsImportModal.stepTwo.number")}
			>
				<select
					id="import-column-number"
					className="form-select w-full"
					onChange={(e) => handleColumns("number", e.target.value)}
					value={columns.number}
				>
					<option value="">{i18n.t("contactsImportModal.stepTwo.select")}</option>
					{headers.map((header) => (
						<option key={header} value={header}>
							{header}
						</option>
					))}
				</select>
			</AuthField>

			<AuthField
				id="import-column-email"
				label={i18n.t("contactsImportModal.stepTwo.email")}
			>
				<select
					id="import-column-email"
					className="form-select w-full"
					onChange={(e) => handleColumns("email", e.target.value)}
					value={columns.email}
				>
					<option value="">{i18n.t("contactsImportModal.stepTwo.none")}</option>
					{headers.map((header) => (
						<option key={header} value={header}>
							{header}
						</option>
					))}
				</select>
			</AuthField>
		</div>
	);
};

export default ModalStepTwo;
